<template>
  <v-card 
    class="schedule-card clickable-card"
    @click="goToSchedule(student.id)"
  >
    <v-card-title class="card-header justify-center">
      <div class="student-name">{{ student.name }}</div>
    </v-card-title>
    <v-card-text class="card-text">
      <div
        v-for="(subject, index) in student.subjects"
        :key="index"
        class="subject-block"
      >
        <div class="subject-left">
          <h3 class="subject-title">
            {{ subject.name }}
          </h3>
          <p class="study-duration">
            {{ $t(`children.studyTime`) }} • {{ subject.schedule.filter(day => day.active).length }}
          </p>
          <div class="schedule">
            <div
              v-for="(day, i) in subject.schedule"
              :key="i"
              class="schedule-day"
            >
              <span :class="['day-badge', { active: day.active }]">{{
                day.name
              }}</span>
              <span class="time">{{ day.time }}</span>
            </div>
          </div>
          <v-divider v-if="index !== student.subjects.length - 1"></v-divider>
        </div>
      </div>
      <div
        style="text-align: center; margin-top: 16px"
        v-if="!student.subjects.length"
      >
        {{ $t(`profile.noSubjects`) }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ScheduleCard",
  props: {
    student: Object,
  },
  methods: {
    goToSchedule(childId) {
      this.$router.push({ name: "Schedule", params: { childId } });
    },
  },
};
</script>

<style scoped>
.clickable-card {
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.clickable-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.clickable-card:active {
  transform: translateY(0);
}

.clickable-card::after {
  content: '';
  position: absolute;
  top: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.clickable-card:hover::after {
  opacity: 1;
}

.student-name {
  max-width: 90%;
  text-align: center;
  word-break: keep-all; /* Не разбивать слова */
  overflow-wrap: break-word;
}

.schedule-card {
  font-family: "Montserrat Alternates", sans-serif;
  width: 304px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.subject-left {
  width: 100%;
}

.card-header {
  background-color: #5e5af9;
  color: white;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding: 15px;
  min-height: 94px;
  height: auto;
}

::v-deep .v-card__text.card-text {
  font-family: "Semibold", sans-serif !important;
}

.subject-block {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.subject-title {
  font-family: "Montserrat Alternates", sans-serif;
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  margin-top: 20px;
  text-align: center;
}

.study-duration {
  font-size: 14px;
  color: #666;
  text-align: center;
}

.schedule {
  display: flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}

.schedule-day {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-width: 20px;
}

.day-badge {
  padding: 4px 10px;
  border-radius: 11px;
  font-size: 12px;
  border: 1px solid #ccc;
  color: #888;
  font-weight: bold;
}

.day-badge.active {
  border-color: #0056b3;
  color: #0056b3;
}

.time {
  font-size: 14px;
  font-weight: bold;
  margin-top: 4px;
}

::v-deep .theme--light.v-divider {
  margin-top: 22px;
}

.center-back-icon {
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  padding: 8px;
  border-radius: 50%;
}

.center-back-icon:hover {
  background-color: rgba(0, 86, 179, 0.1);
  color: #0056b3 !important;
}

@media (max-width: 1024px) {
  .schedule-card {
    max-width: 100%;
  }
  .card-header {
    font-size: 15px;
  }
}

@media (max-width: 960px) {
  .schedule-card {
    max-width: 100%;
  }
}

@media (max-width: 960px) and (min-width: 768px) {
  .schedule-card {
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .schedule-card {
    max-width: 100%;
  }

  .card-header {
    font-size: 16px;
  }

  .subject-title {
    font-size: 14px;
  }

  .day-badge {
    font-size: 12px;
    padding: 3px 8px;
  }

  .time {
    font-size: 12px;
  }
}

@media (max-width: 600px) {
  .schedule-card {
    margin: 0 auto;
  }
}
</style>
